import { render, staticRenderFns } from "./DocumentGroupFileAddEditModal.vue?vue&type=template&id=3b9174c2&scoped=true&"
import script from "./DocumentGroupFileAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupFileAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroupFileAddEditModal.vue?vue&type=style&index=0&id=3b9174c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9174c2",
  null
  
)

export default component.exports